export const SET_FOOTER_ICONS = 'SET_FOOTER_ICONS';
export const TOGGLE_POPOVER = "TOGGLE_POPOVER";
